import React from "react";
import "./ServicePages.scss";

//Panels
import Hero from "./Components/Hero";

//Images
import walkways from "./images/walkways/bg-walkways.jpg";
import featureA1 from "./images/walkways/feature-a-1.jpg";
import featureA2 from "./images/walkways/feature-a-2.jpg";
import featureA3 from "./images/walkways/feature-a-3.jpg";
import featureB1 from "./images/walkways/feature-b-1.jpg";
import featureB2 from "./images/walkways/feature-b-2.jpg";
import featureB3 from "./images/walkways/feature-b-3.jpg";
import featureC1 from "./images/walkways/Antique-Cobble-I-Charcoal-Tumbled.jpg";
import featureC2 from "./images/walkways/BEL2018_Coastal_Swatch_Appian_Titanium_0.jpg";
import featureC3 from "./images/walkways/timberline-stone-adobe-mocha.jpg";

//SEO
import SEO from "../../../SEO/index.js";
import StructuredData from "../../../SEO/structuredData";

const Walkways = () => {
  return (
    <>
      <SEO
        title="Paver Walkway Contractors | Los Angeles | Pacific Pavingstone"
        description="Get the paver walkway look and functionality you want by working with the professional paver installers and licensed contractors from Pacific Pavingstone."
        profileURL={"https://www.pacificpavingstone.com/services/walkways"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "Service",
          name: "Paver Walkway Contractors",
          image:
            "https://www.pacificpavingstone.com/static/media/bg-walkways.a833e93b.jpg",
          description:
            "Depending on your home’s aesthetic, there are two major options for steps and coping; Paving stones or Poured concrete. Request an estimate today!",
          brand: "Pacific Pavingstone",
          areaServed: "Southern California",
          logo: "https://www.pacificpavingstone.com/static/media/logo-2.bf1f43f9.png",
          provider: "Pacific Pavingstone",
          URL: "https://www.pacificpavingstone.com/services/walkways",
          potentialAction: "Schedule a Consultation",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5",
            bestRating: "5",
            worstRating: "1",
            ratingCount: "1",
            reviewCount: "1",
          },
          review: {
            "@type": "Review",
            name: "R.R.",
            reviewBody:
              "Every once in a while I come across a contractor whose standards are exceptional on all levels. Pacific Pavingstone is one of those contractors! They recently installed an 1,100 sq ft paver stone driveway, numerous cantilevered concrete steps, board formed concrete planter walls and landscaping that is of the highest quality and that we just LOVE! Furthermore, Trent, John, Luis and their entire staff were always a pleasure to work with and the entire experience was easy and stress-free too! If you want a contractor that is professional, does outstanding quality work and one that you will not lose any sleep over, Pacific Pavingstone is the one for you!",
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5",
              bestRating: "5",
              worstRating: "1",
            },
            datePublished: "2021-10-08",
            author: { "@type": "Person", name: "R.R." },
            publisher: { "@type": "Organization", name: "Pacific Pavingstone" },
          },
        }}
      />
      <div className="container-fluid page-featured">
        <Hero title={"Walkways"} background={walkways} />
        <div className="row justify-content-center">
          <div className="col-11 col-md-9">
            <div className="row justify-content-center panel-content pb-4">
              <div className="col-12">
                <p>
                  Walkways are a fundamental part of any residential or
                  commercial property. This especially rings true for sloping
                  landscapes. Without a pathway, merely walking from the street
                  to your front door can become a chore. Paver walkways make
                  getting around your yard a lot easier. Walkways attract a huge
                  amount of foot traffic so they need to be extra durable. They
                  not only lead your guests from one area to another in your
                  outdoor living space, they also help prevent visitors from
                  carving their own path around your yard. Most important,
                  walkways also increase the overall appeal and functionality of
                  your property. If you’re looking to remodel your walkways,
                  make sure to plan ahead of time. Professional paver installers
                  and licensed contractors can help you look into various
                  materials and designs for paver walkways.
                </p>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Materials You Can Use for Your Paver Walkways
                </h2>
                <p>
                  Each paving material can give your outdoor spaces a distinct
                  look and feel. Natural stone makes a great choice if you want
                  to achieve a close-to- nature look. Customization can come
                  challenging, but that’s the beauty of it – its raw, untouched
                  look.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <p>
                  On the other hand, if you’re looking for a more structured
                  look, you’d enjoy more flexibility with concrete and brick
                  pavers. You can choose from various shapes, colors and even
                  textures. You can also mix and match different paving stones
                  to create patterns throughout your design. Take cues from
                  other paving installations in your yard such as your driveway
                  or patio to seamlessly blend your walkway into the other
                  spaces. You can also seal your pavers to protect the color and
                  prevent damage from the elements.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12"></div>
              <div className="col-12 mt-4">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style">
                      <img
                        className="mb-2 mb-lg-0"
                        src={featureC1}
                        alt="Angelus Antique Cobble in Tumbled Charcoal"
                      />
                      <div className="text">
                        <p>
                          Angelus Antique Cobble
                          <br />
                          In Tumbled Charcoal
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style">
                      <img
                        className="mb-2 mb-lg-0"
                        src={featureC2}
                        alt="Belgard Cambridge Cobble® In Titanium"
                      />
                      <div className="text">
                        <p>
                          Belgard Cambridge Cobble®
                          <br />
                          In Titanium
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style">
                      <img
                        className="mb-2 mb-lg-0"
                        src={featureC3}
                        alt="Angelus Timberline in Stone Adobe-Mocha"
                      />
                      <div className="text">
                        <p>
                          Angelus Timberline
                          <br />
                          In Stone Adobe-Mocha
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Walkways;
